import style from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import ArticleTile from '../../components/article-tile/index';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/navigation';

SwiperCore.use([Navigation]);

function SwiperPosts({ posts }) {
    const { t } = useTranslation();

    const sliderSettings = {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 500,
        loop: false,
        navigation: true,
    };

    const mobileBreakpointInt = style.mobileBreakpoint.slice(0, 3);
    const tabletBreakpointInt = style.tabletBreakpoint.slice(0, 3);
    const laptopBreakpointInt = style.laptopBreakpoint.slice(0, 4);

    const swiperBreakPoints = {
        [mobileBreakpointInt]: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        [tabletBreakpointInt]: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        [laptopBreakpointInt]: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        1444: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    };

    return (
        <>
            <Swiper {...sliderSettings} className={style.posts} breakpoints={swiperBreakPoints}>
                {posts.length > 0 &&
                    posts.map((article, key) => {
                        return (
                            <SwiperSlide key={key}>
                                <ArticleTile content={article} />
                            </SwiperSlide>
                        );
                    })}
                {posts.length === 0 && <p className={style.noPosts}>{t("Aucun article n'est disponible")}</p>}
            </Swiper>
        </>
    );
}

export default SwiperPosts;
